<template>
  <my-profile-menu-layout>
    <my-profile-user-limits></my-profile-user-limits>
  </my-profile-menu-layout>
</template>

<script>
  import MyProfileMenuLayout from "@/components/layout/MyProfileMenuLayout";
  import MyProfileUserLimits from "@/components/myprofile/MyProfileUserLimits";
  import CurrentUserMixin from "@/mixins/CurrentUserMixin";

  export default {
    name: "ProfileUserLimits",
    data() {
      return {
      }
    },
    mixin: [CurrentUserMixin],
    mounted() {
      this.$store.commit('user/set_current_project_id', this.project_id)
    },
    methods: {
    },
    components: {
      MyProfileMenuLayout, MyProfileUserLimits
    },
  }
</script>

<style scoped>

</style>